import { AdministrationHelper } from "@/Administration/Helpers/AdministrationHelper";
import { TextboxControl } from "@/Common/Components/Inputs/TextboxControl";
import { useTranslation } from "@/Common/CustomHooks/useTranslation";
import { LocalizedTextDto } from "@/Common/Models/LocalizedTextDto";
import { SiteCreateState } from "../../SiteCreate";

interface ISiteOnlineNameSubSectionProps {
    localizedDisplayName: LocalizedTextDto;
    mutateState: (mutation: (state: SiteCreateState) => void, then?: () => void) => void;
}

function SiteOnlineNameSubSection(props: ISiteOnlineNameSubSectionProps): JSX.Element {
    const { getText } = useTranslation();
    const { localizedDisplayName, mutateState } = props;

    const onChangeHandle = (value: string, propertyName: string): void => {
        mutateState(s => s.localizedDisplayName = {
            ...localizedDisplayName,
            [propertyName]: value
        });
    };

    return (
        <>
            <div className="view-subsection-header row">
                <div className="col-lg-4 col-md-2 col-sm-2 text-right">
                    <h4 className="view-subsection-title">{getText("ClinicInfo_SiteOnlineNameLabel")}</h4>
                </div>
            </div>

            <div className="view-subsection-body">
                {AdministrationHelper.getLocalizedTextSiteCreateArray(localizedDisplayName).map((item, index) => (
                    <div key={`website_${index}`} className="row margin-md-bottom">
                        <div className="col-lg-4 col-md-3 col-sm-12 vcenter text-right">
                            <label className="form-label">{item.languageName}</label>
                        </div>
                        <div className="col-lg-5 col-md-9 col-sm-12">
                            <TextboxControl
                                className="form-control"
                                maxLength={AdministrationHelper.maxNoteLengthLimit}
                                onChange={value => {
                                    if (value.length > AdministrationHelper.maxNoteLengthLimit) {
                                        return;
                                    }
                                    onChangeHandle(value, item.propertyName);
                                }}
                                value={item.value}
                            />
                            <label data-cy="counter-label">
                                {`${item.value?.length ?? 0}/${AdministrationHelper.maxNoteLengthLimit}`}
                            </label>
                        </div>
                    </div>
                ))}
            </div>
        </>
    );
}

export { ISiteOnlineNameSubSectionProps };
export default SiteOnlineNameSubSection;
